import {
	Component,
	computed,
	inject,
	input,
	OnInit,
	Renderer2,
} from '@angular/core';

import { DynamicModule, InputsType } from 'ng-dynamic-component';

import { Components } from '@valk-nx/storyblok/components/reference/src/lib/reference.component';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import { StoryblokHelper } from '@valk-nx/storyblok-helpers/src/lib/general/storyblok.helper';
import { MetadataService } from '@valk-nx/storyblok-services/src/lib/services/metadata.service';
import { ISbStoryBlok } from '@valk-nx/storyblok-types/src/lib/types/storyblok.types';

@Component({
	selector: 'sb-page',
	templateUrl: './page.component.html',
	imports: [DynamicModule],
})
export class PageComponent extends StoryblokRootDirective implements OnInit {
	private readonly metadataService = inject(MetadataService);
	private readonly renderer2 = inject(Renderer2);

	components: typeof Components = Components;

	readonly content = input<ISbStoryBlok[]>([]);
	readonly metaDescription = input<string>('');
	readonly metaTitle = input<string>('');

	contentInput = computed((): (InputsType & { component: string })[] => {
		const contentValue = this.content();
		return contentValue && contentValue.length > 0
			? contentValue.map((blok) => ({
					...blok,
					component: blok['component'] ?? '',
				}))
			: [];
	});

	ngOnInit() {
		const contentValue = this.content();
		if (contentValue && contentValue.length > 0) {
			const faqs = StoryblokHelper.getAllAccordionItems(contentValue);
			if (faqs.length > 0) {
				this.metadataService.setSchemaOrgFaq(
					this.renderer2,
					this.metaTitle(),
					this.metaDescription(),
					faqs,
				);
			}
		}
	}
}
